import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = ["La Guía Maestra 'Renacer en 7 Días' (PDF Digital descargable)", "Protocolo 'Botánica Sagrada': Cuándo y cómo usar Women's Choice y Tang Kuei para resultados máximos", 'Planificador de Rutina Diaria: Horarios de hidratación, descanso y nutrición', 'Guía de Movimiento Suave: Ejercicios de 15 minutos que no agotan tus adrenales', 'Lista de Compras Anti-Inflamatoria para la mujer latina'];
  return <section className="py-20 px-6 md:px-12 bg-warm-dark text-cream" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <FadeIn data-id="element-167">
          <div className="text-center mb-12" data-id="element-168">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-169">
              ¿Qué Incluye Tu Guía?
            </h2>
            <div className="w-24 h-1 bg-rose-gold mx-auto rounded-full" data-id="element-170"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-171">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-172">
              <div className="flex items-start space-x-4 bg-white/5 p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors" data-id="element-173">
                <CheckCircle2 className="w-6 h-6 text-rose-gold flex-shrink-0 mt-1" data-id="element-174" />
                <p className="text-lg font-sans leading-relaxed text-cream/90" data-id="element-175">
                  {item}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}